import React from 'react';
import { concatStyles } from 'utils';
var HEADLINE_STYLES = 'font-heading text-headline text-body text-md font-black mb-0 uppercase tracking-tight';
export var Headline = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("h3", { className: concatStyles([HEADLINE_STYLES, className]) }, children));
};
Headline.displayName = 'Card.Headline';
